var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CCardBody',[_c('CDataTable',{attrs:{"items":_vm.transactionsData,"fields":_vm.fields,"items-per-page-select":"","items-per-page":10,"hover":"","sorter":"","pagination":"","table-filter":"","cleaner":""},scopedSlots:_vm._u([{key:"SN",fn:function(ref){
var index = ref.index;
return [_c('td',[_vm._v(" "+_vm._s(index++)+" ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }